import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { BaseService } from '../../services/base.service';
import { BaseDocumentDownload } from '../base/base-document-download';
import { BaseDocument } from '../base/base.document';
import { User } from './user.model';

@Injectable({
    providedIn: 'root'
})
export class UserService extends BaseService {

    constructor(http: HttpClient) {
        super(http, 'user');
    }

    getAll() {
        return this.http.get<User[]>(this.baseUrl);
    }

    get(id: string) {
        return this.http.get<User>(this.baseUrl + '/' + id);
    }

    post(item: User) {
        return this.http.post<User>(this.baseUrl, item);
    }

    put(id: string, item: User) {
        return this.http.put<User>(this.baseUrl + '/' + id, item);
    }

    delete(id: string) {
        return this.http.delete<void>(this.baseUrl + '/' + id);
    }

    me() {
        return this.http.get<User>(this.baseUrl + '/me');
    }

    report(from: string, to: string) {
        return this.http.get<BaseDocument[]>(this.baseUrl + '/report/' + from + '/' + to);
    }

    getByCompanyId(companyId: number) {
        return this.http.get<User[]>(this.baseUrl + '/getByCompanyId/' + companyId);
    }

    acceptInformationAgreement(item: User){
        return this.http.post<User>(this.baseUrl + '/acceptInformationAgreement' ,
         {...item, managerEmail: item.managerEmail !== null && item.managerEmail.trim() === '' ? null : item.managerEmail,
          informationAgreement: true});
    }

    cancellationRequest(id: string){
        return this.http.get<User>(this.baseUrl + `/cancellationRequest/${id}`);
    }

    downloadDocuments(id: string){
        return this.http.get<BaseDocumentDownload[]>(this.baseUrl + `/downloadDocuments/${id}`);
    }
}
